import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SystemService } from 'src/app/base/services/system.service';
import { SharingService } from '../../services/sharing.service';
import { WebpayService } from '../../services/webpay.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-error-webpay',
  templateUrl: './error-webpay.component.html',
  styleUrls: ['./error-webpay.component.css']
})
export class ErrorWebpayComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private sharingObservable: SharingService,
    private webpay: WebpayService,
    private systemService: SystemService,
    @Inject(DOCUMENT) private document: Document) { }

  data: any;

  ngOnInit(): void {
    this.systemService.setLoading(true);

    this.sharingObservable.sharingObservable.subscribe((e: any) => {
      this.data = JSON.parse(e);
    });

    this.systemService.setLoading(false);

  }

  async volver() {
    this.systemService.setLoading(true);
    this.document.location.href = await this.webpay.setBotonVolver(window.location.href.split('?uid=')[1], this.data.urlRetorno);
    this.systemService.setLoading(false);
  }

}
